var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"websocket--container"},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showSuccess)?_c('div',{staticClass:"websocket--success status-done"},[_vm._v(" Соединение установлено ")]):_vm._e(),(_vm.showDanger)?_c('div',{staticClass:"websocket--danger status-new"},[_vm._v(" Отсутствует соединение ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }